import { useIntl } from "react-intl";

const MajorIncidentEscalation = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MajorIncidentEscalation.header",
            defaultMessage: "Major incident escalation"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MajorIncidentEscalation.body",
            defaultMessage:
                "Use an incident management process to identify affected services, track related issues, and escalate to the correct team."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default MajorIncidentEscalation;
